import { FC, useEffect } from "react";
import { ClientProps } from "../../hooks/useClientData";
import { brand } from "../../brandVariables/getBandVariables";
import "./styles/index.scss";
import { useTimer } from "../../hooks/useCountDown";
import { TextWithLines } from "./components/TextWithLines/TextWithLines";
import { UserCard } from "./components/userCard/UserCard";
import { setCurrentChallengeToOnGoing } from "@/helperFunctions/setCurrentChallengeToOnGoing";
import { HalfunderLinedText } from "./components/halfUnderLinedtext/HalfUnderLinedText";
export const CS2TIMEDWaitingScreen: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const { time, startTimer, timeObj, isTimeOver, clearTimer } = useTimer(
    clientData.nextChallenges?.data?.[0]?.startDate || undefined
  );

  useEffect(() => {
    let hasRan;

    if (
      !clientData.challenge.data &&
      !hasRan &&
      !clientData.nextChallenges.loading &&
      clientData.nextChallenges.data?.[0] &&
      isTimeOver
    ) {
      hasRan = true;

      setCurrentChallengeToOnGoing(clientData.nextChallenges.data?.[0].slug);
    }
  }, [time, isTimeOver]);

  const hasClientData =
    clientData.winners.data === null || clientData.winners.data.length === 0;
  const Logo = brand.brandLogo;
  console.log(clientData.winners.data);

  return (
    <>
      <div className="waiting-screen">
        <section>
          <div className="waiting-screen__countdown">
            <div className="waiting-screen__heading">
              <div className="brand-logo">
                <Logo />
              </div>
            </div>
            {/* <h2>Join us in</h2> */}
            {hasClientData ? (
              <TextWithLines text="cs2 challenge start in" />
            ) : (
              <TextWithLines text="next cs2 challenge in" />
            )}

            <section>
              <div className="time_section">
                <div className="time">
                  <p>{timeObj?.hours.replace(":", "")[0] || "-"}</p>
                  <p>{timeObj?.hours.replace(":", "")[1] || "-"}</p>
                </div>
                <div className="time_type">hrs</div>
              </div>
              <span />
              <div className="time_section">
                <div className="time">
                  <p>{timeObj?.minutes.replace(":", "")[0] || "-"}</p>{" "}
                  <p>{timeObj?.minutes.replace(":", "")[1] || "-"}</p>
                </div>
                <div className="time_type">mins</div>
              </div>
              <span />
              <div className="time_section">
                <div className="time">
                  <p>{timeObj?.seconds.replace(":", "")[0] || "-"}</p>{" "}
                  <p>{timeObj?.seconds.replace(":", "")[1] || "-"}</p>
                </div>
                <div className="time_type">Sec</div>
              </div>
            </section>
          </div>
        </section>

        {hasClientData && (
          <div className="waiting-screen__countdown">
            <h3>All participants are in a raffle for a</h3>
            {brand.prize && brand.prize.nameOf && brand.prize.typeOfItem && (
              <h4>
                <HalfunderLinedText text={` ${brand.prize.typeOfItem}`} />
              </h4>
            )}
          </div>
        )}

        {
          !hasClientData && clientData.winners.data.length !== 0 ? (
            <section>
              <div className="waiting-screen__winners">
                <div className="winners">
                  <div className="winners__heading">
                    <p>previous winners</p>
                  </div>
                </div>
                <ul>
                  {clientData.winners.data.slice(0, 3).map((winner) => {
                    return (
                      <UserCard
                        user={{
                          profile: {
                            userName: winner.userName,
                            profileLogoUrl: winner.userProfileLogoUrl,
                          },
                          userChallengeData: {
                            points: winner.points,
                          },
                        }}
                        place={undefined}
                      />
                    );
                  })}
                </ul>
              </div>
            </section>
          ) : (
            ""
          )
          //  (
          //   <div className="waiting-screen__countdown">
          //     <h3>Winner of each challenge gets a</h3>
          //     {brand.prize && (
          //       <h4>
          //         {brand.prize.nameOf} {brand.prize.typeOfItem}
          //       </h4>
          //     )}
          //   </div>
          // )
        }
      </div>
    </>
  );
};
